<div>
  <p>Version: <b>{{version}}</b></p>
  <p>
    GitHub SHA: <b>{{GITHUB_SHA}}</b>
  </p>
</div>
